import type { Workspace } from "@/supabase.types";

export const createWorkspacesTree = (workspaces: Workspace[]) => {
  const workspaceChildrenMap = workspaces.reduce<Record<string, { workspace?: Workspace; children: Workspace[] }>>(
    (reduceObj, workspace) => {
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (!reduceObj[workspace.id]) {
        reduceObj[workspace.id] = { workspace, children: [] };
      } else reduceObj[workspace.id].workspace ??= workspace;
      if (workspace.creator_workspace_id) {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (!reduceObj[workspace.creator_workspace_id]) {
          reduceObj[workspace.creator_workspace_id] = { workspace: undefined, children: [] };
        }
        reduceObj[workspace.creator_workspace_id].children = [
          ...reduceObj[workspace.creator_workspace_id].children,
          workspace,
        ];
      }
      return reduceObj;
    },
    {},
  );

  const topLevelWorkspaces: (Workspace & { children: Workspace[]; level: number })[] = [];
  for (const workspace_id of Object.keys(workspaceChildrenMap)) {
    const element = workspaceChildrenMap[workspace_id];
    if (
      element.workspace &&
      (!element.workspace.creator_workspace_id ||
        !workspaceChildrenMap[element.workspace.creator_workspace_id].workspace)
    ) {
      topLevelWorkspaces.push({ ...element.workspace, children: element.children, level: 0 });
    } else {
      topLevelWorkspaces.concat(
        element.children.map((workspaceRaw) => ({
          ...workspaceRaw,
          level: 0,
          children: workspaceChildrenMap[workspaceRaw.id].children,
        })),
      );
    }
  }

  let level = 1;
  let finalWorkspaces: (Workspace & { children?: Workspace[]; level: number })[] = topLevelWorkspaces;
  while (finalWorkspaces.some((workspace) => workspace.children)) {
    finalWorkspaces = finalWorkspaces
      .flatMap((workspace) => {
        const { children, ...workspaceRaw } = workspace;
        return workspace.children
          ? [
              workspaceRaw,
              workspace.children.map((workspaceChild) => ({
                ...workspaceChild,
                level,
                children: workspaceChildrenMap[workspaceChild.id].children,
              })),
            ]
          : workspace;
      })
      .flat();
    ++level;
  }

  return finalWorkspaces;
};
